import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { apiGet } from "../api/client";
import { EmptyMessage } from "../components/EmptyMessage";
import { PageHeader, PageHeaderAction } from "../components/PageHeader";

export type FormSummary = {
  id: string;
  name: string;
  response_count?: number;
  updated_at?: string;
};

/** Historical forms grid (`forms/forms.html` / app.forms). */
export function FormsPage() {
  const [forms, setForms] = useState<FormSummary[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    apiGet<FormSummary[]>("/forms")
      .then((d) => {
        if (!cancelled) setForms(Array.isArray(d) ? d : []);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="ne__forms">
      <PageHeader
        title="Forms"
        actions={
          <PageHeaderAction title="Create new form" icon="ne__icon__add" />
        }
      />
      {loading ? (
        <EmptyMessage>
          <p>Loading forms…</p>
        </EmptyMessage>
      ) : null}
      {!loading && forms.length === 0 ? (
        <EmptyMessage title="No forms yet." />
      ) : null}
      {!loading && forms.length > 0 ? (
        <section className="ne__forms__grid-view" style={{ padding: "2.5vw 5%" }}>
          <ul className="ne__tile__grid" style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexWrap: "wrap" }}>
            {forms.map((form) => (
              <li
                key={form.id}
                className="ne__tile ne__tile--primary"
                style={{ width: "calc(100% / 12 * 3)", padding: "1rem", boxSizing: "border-box" }}
              >
                <Link className="ne__tile__button" to={`/app/forms/${form.id}/edit`}>
                  <div className="ne__tile__content">
                    <div className="ne__tile__body">
                      <i className="ne__tile__icon ne__icon__forms--thinnest" aria-hidden="true" />
                      <h3 className="ne__tile__name">{form.name}</h3>
                    </div>
                    {form.response_count != null ? (
                      <div className="ne__tile__bottom">
                        <ul className="ne__tile__info">
                          <li className="ne__tile__count">
                            {form.response_count} responses
                          </li>
                        </ul>
                      </div>
                    ) : null}
                  </div>
                </Link>
              </li>
            ))}
          </ul>
        </section>
      ) : null}
    </div>
  );
}
